module.exports = __webpack_public_path__ + "img/industrial-icon.216d036f.svg";